export const QUERIES = {
  search: 'search',
};
